import ApiService from '@/common/ApiService/ApiService';
import { StatusObjectT } from '@/common/ApiService/StatusObject';
import ApiServiceOptions from '@/common/ApiService/ApiServiceOptions';
import Address from '@/common/interfaces/dto/Address';

export interface MessagesModel {
  Messages: string[];
}

export interface ZipValidationResult {
  DefaultCity: string;
  StateAbbreviation: string;
}

export interface AddressSuggestion {
  text: string;
  street_line: string;
  city: string;
  state: string;
}

export interface StreetAutocompleteParams {
  street: string;
  city: string;
  state: string;
}

export interface AddressValidatorItem {
  AddressLine1: string;
  AddressLine2: string;
  Country: string;
  Locality: string;
  PostalCode: string;
  Province: string;
}

const apiService = new ApiService('/api/AddressValidatorApiService', {
  returnData: true,
  cancel: true,
});

export const validate = async (
  address: Address,
  options?: ApiServiceOptions,
): Promise<StatusObjectT<Address | MessagesModel>> => {
  let result: StatusObjectT<Address | MessagesModel> = {
    IsOk: false,
    Error: '',
    Item: { Messages: [] },
  };
  await apiService
    .call('Validate', address, options)
    .then((data) => {
      result.Item = data;
      result.IsOk = true;
    })
    .catch((error) => {
      result.Item = { Messages: error?.response?.data?.Messages };
      result.Error = error?.response?.data?.Message;
    });
  return result;
};

export const getInfoByZipCode = async (
  zipCode: string,
  options?: ApiServiceOptions,
): Promise<StatusObjectT<ZipValidationResult>> => {
  let result: StatusObjectT<ZipValidationResult> = {
    IsOk: false,
    Error: '',
    Item: { DefaultCity: '', StateAbbreviation: '' },
  };
  await apiService
    .call('GetZipInfo', { zipCode }, options)
    .then((data) => {
      result.Item = data;
      result.IsOk = true;
    })
    .catch((error) => {
      result.Error = error?.response?.data?.Message;
    });
  return result;
};

export const getAddressSuggestions = async (
  params: StreetAutocompleteParams,
  options?: ApiServiceOptions,
): Promise<StatusObjectT<AddressSuggestion[]>> => {
  let result: StatusObjectT<AddressSuggestion[]> = {
    IsOk: false,
    Error: '',
    Item: [],
  };
  await apiService
    .call('GetStreetAutocomplete', params, options)
    .then((data) => {
      result.Item = data;
      result.IsOk = data?.length > 0 ? true : false;
    })
    .catch((error) => {
      result.Error = error?.response?.data?.Message;
    });
  return result;
};
